<template>
    <div>
        <a id="skip" href="#mainContent">{{ $t('skip_content') }}</a>
        <DelayHydration>
            <LazyWebsiteHeaderWrapper />
        </DelayHydration>
        <DelayHydration>
            <LazyCookieBanner />
        </DelayHydration>
        <slot></slot>
    </div>
</template>

<style lang="scss">
#skip {
    display: none;
}
</style>